import { usePostHog } from "posthog-js/react";

export function useTrackWordClicked() {
  const posthog = usePostHog();

  const trackWordClicked = () => {
    posthog.capture("word_clicked");
  };

  return trackWordClicked;
}
